var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1317 8.07139C15.1317 7.54516 15.0845 7.03916 14.9968 6.55341H8.00732V9.42409H12.0013C11.8293 10.3517 11.3064 11.1377 10.5204 11.664V13.526H12.9189C14.3222 12.2341 15.1317 10.3315 15.1317 8.07139Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00735 15.3239C10.0111 15.3239 11.691 14.6594 12.9189 13.526L10.5205 11.6639C9.85592 12.1092 9.00585 12.3723 8.00735 12.3723C6.07444 12.3723 4.43839 11.0668 3.85481 9.31271H1.37543V11.2355C2.59656 13.6609 5.1063 15.3239 8.00735 15.3239Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85479 9.31272C3.70637 8.86745 3.62204 8.39181 3.62204 7.90268C3.62204 7.41355 3.70637 6.93792 3.85479 6.49264V4.56985H1.37541C0.872791 5.57173 0.58606 6.70516 0.58606 7.90268C0.58606 9.1002 0.872791 10.2336 1.37541 11.2355L3.85479 9.31272Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00735 3.43306C9.09693 3.43306 10.0752 3.80749 10.8443 4.54288L12.9729 2.41432C11.6876 1.2168 10.0077 0.481415 8.00735 0.481415C5.1063 0.481415 2.59656 2.14445 1.37543 4.56986L3.85481 6.49265C4.43839 4.73853 6.07444 3.43306 8.00735 3.43306Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.64636dfdbd3d0fb95d2cd68ef6e3a0be.svg";
export { ForwardRef as ReactComponent };